var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNuevi(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 256,
    height: 256,
    fill: "#081F2C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M121.789 120.525C121.789 104.304 113.073 98.5108 99.6298 98.5108C94.5148 98.5494 89.4768 99.7354 84.9017 101.978C80.3266 104.221 76.3359 107.46 73.2355 111.449V194H30V64.3552H73.2108V76.0381L67.9172 85.6934C76.0423 76.3519 97.4631 61 120.09 61C150.966 61 165 78.5967 165 103.097V194H121.789V120.525Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M179 170.5C179 164.267 181.423 158.29 185.737 153.883C190.05 149.476 195.9 147 202 147C208.1 147 213.95 149.476 218.263 153.883C222.577 158.29 225 164.267 225 170.5C225 176.733 222.577 182.71 218.263 187.117C213.95 191.524 208.1 194 202 194C195.9 194 190.05 191.524 185.737 187.117C181.423 182.71 179 176.733 179 170.5Z",
    fill: "#E40046"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNuevi);
export default __webpack_public_path__ + "static/media/nuevi.7d45dba975f08edfd790d2fd081a7d60.svg";
export { ForwardRef as ReactComponent };